import { ColDef } from "ag-grid-community";
import { JsonSchema, JsonSchemaPropertyMap } from "../../../../types";
import { SETUP_IDENTIFIER_FIELDS } from "../../constants";

// schema helpers
export const getIdentifierFields = (schema: JsonSchema): string[] =>
  SETUP_IDENTIFIER_FIELDS[schema.title] ?? [];

export const getIdentifierProperties = (
  schema: JsonSchema,
): JsonSchemaPropertyMap =>
  Object.fromEntries(
    getIdentifierFields(schema)
      .map((key) => [key, schema.properties[key]])
      .filter(([, property]) => property),
  );

export const getAllFieldProperties = (
  schema: JsonSchema,
  correlationProperties: JsonSchemaPropertyMap,
): JsonSchemaPropertyMap => ({
  ...getIdentifierProperties(schema),
  ...correlationProperties,
});

export const getFieldTitles = (
  properties: JsonSchemaPropertyMap,
  includeHidden = false,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(properties)
      .filter(([, property]) => includeHidden || !property?.isHidden)
      .map(([key, property]) => [key, property.title]),
  );

export const getTableCorelationFieldsSchemaTitles = (
  correlationProperties: JsonSchemaPropertyMap,
): Record<string, string> => getFieldTitles(correlationProperties);

export const getCorelationFieldsSchemaTitles = (
  correlationProperties: JsonSchemaPropertyMap,
): Record<string, string> => getFieldTitles(correlationProperties, true);

export const getIdentifiersFieldsSchemaTitles = (
  schema: JsonSchema,
): Record<string, string> =>
  getFieldTitles(getIdentifierProperties(schema), true);

// table col defs
export const getCorelationFieldsColDefs = (
  correlationProperties: JsonSchemaPropertyMap,
  schema: JsonSchema,
): ColDef[] =>
  Object.entries(getAllFieldProperties(schema, correlationProperties))
    .filter(([, property]) => !property?.isHidden)
    .map(([key, property]) => ({
      field: key,
      headerName: property.title,
    }));
